import React from "react";
import "./StartTest.scss";
import { Button, WingBlank, Modal, Toast } from "antd-mobile";
import withAuth from "../../HOCs/withAuth";
import http from "../../util/api";
import { getItem } from "../../util/util";
import moment from "moment";
import qs from "qs";

//
class StartTest extends React.Component {
  state = {
    batchId: "", //考试批次id
    testBatchId: "", //
    visible: false,
    name: `${JSON.parse(getItem("userInfo")).Data}`,
    myInterview: {} //我的当前面试记录
  };
  componentDidMount() {
    const { location } = this.props;
    window.V5CHAT("hideBtn");
    const search = document.location.search;
    const querystring = search.substring(1);
    const qsObj = qs.parse(querystring);
    const batchId = (location.state && location.state.batchId) || qsObj.batchId,
      testBatchId =
        (location.state && location.state.testBatchId) || qsObj.testBatchId;
    if (batchId && testBatchId) {
      this.setState({ batchId, testBatchId });
      this.getInterview(batchId);
    } else {
      this.setState({ visible: true });
    }
  }

  isStartTest = async () => {
    try {
      let res = await http().getTable({
        resid: "617193728135",
        cmswhere: `testBatchId = '${this.state.testBatchId}'`
      });
      if (res.data.data.length) {
        if (res.data.data[0].C3_617996895368 === "Y") {
          const myInterview = this.state.myInterview;
          if (!myInterview.C3_617724261149) {
            await http().modifyRecords({
              resid: "617190472818",
              data: [
                {
                  REC_ID: this.state.myInterview.REC_ID,
                  C3_617724261149: moment().format("YYYY-MM-DD HH:mm:ss")
                }
              ]
            });
          }
          this.props.history.push(`/answer_questions/${this.state.batchId}`);
        } else {
          Toast.info("考试尚未开始，请稍等");
        }
      }
    } catch (error) {
      console.log(error.message);
      Toast.fail(error.message);
    }
  };

  getInterview = async batchId => {
    try {
      let res = await http().getTable({
        resid: "617190472818",
        cmswhere: `batchId = '${batchId}'`
      });
      this.setState({
        myInterview: res.data.data[0]
      });
    } catch (error) {
      console.log(error.message);
      Toast.fail(error.message);
    }
  };

  render() {
    return (
      <div className="start_test">
        <div className="content">
          <div className="content_main">
            <div className="finisar_logo" />
            <div className="content_main-personinfo">
              <span>
                <img
                  src={getItem("headurl")}
                  alt=""
                  style={{
                    height: "7.96vh",
                    width: "7.96vh",
                    marginRight: "1rem"
                  }}
                />
              </span>
              <span>{this.state.name}</span>
            </div>
            <div className="content_main-tips">
              <p>签到完成</p>
              <p>请在考官宣布考试后</p>
              <p>点击“开始考试”</p>
            </div>
          </div>
          <WingBlank className="start_test-btn">
            <Button type="primary" onClick={this.isStartTest}>
              开始考试
            </Button>
          </WingBlank>
        </div>
        <Modal
          visible={this.state.visible}
          title="提示"
          transparent
          maskClosable={false}
          footer={[
            {
              text: "知道了",
              onPress: () => {
                this.setState({ visible: false });
                this.props.history.push("/scan_qrcode");
              }
            }
          ]}
        >
          请扫码签到后进入
        </Modal>
      </div>
    );
  }
}

export default withAuth(StartTest);
